<template>
  <div class="input-group" v-if="minyear">
    <select class="form-control" v-model="month">
      <option v-for="(name, index) in monthnames" :value="index+1">{{ name }}</option>
    </select>
    <input class="form-control" v-model="year" type="number" step="1" :min="minyear" :max="maxyear" />
  </div>
</template>

<script>
  import {abstractField} from "vue-form-generator";
  import {Italian} from 'flatpickr/dist/l10n/it';

  export default {
    name: 'field-month',
    mixins: [abstractField],
    data () {
      var month, year, regextest = /^[12][0-9]{3}-[0-9]{2}$/;
      if (this.value && typeof this.value === 'string' && regextest.test(this.value)) {
        var values = this.value.split('-');
        month = Number(values[1]);
        year = Number(values[0]);
      } else {
        year = Number((new Date()).getFullYear());
        month = (new Date()).getMonth() + 1;
      }
      return {
        month,
        year,
        months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
        maxyear: (new Date()).getFullYear(),
      }
    },
    computed: {
      monthnames () {
        switch (this.$i18n.i18next.language) {
          case 'it':
            if (Italian && Italian.months && Italian.months.longhand) {
              return Italian.months.longhand;
            }
          default:
        }
        return this.months;
      },
      
    },
    asyncComputed: {
      minyear () {
        return this.async('apptoken')
          .then(token => {
            return new Date(token.created_at.replace(' ', 'T')).getFullYear();
          })
          .catch(e => 2000)
          .then(y => Number(y) || 2000)
        ;
      }
    },
    methods: {
      setvalue () {
        if (!this.month) {
          this.month = (new Date()).getMonth() + 1;
        }
        this.value = String(this.year).padStart(4, '0') + '-' + String(this.month).padStart(2, '0');
      }
    },
    mounted () {
      this.setvalue();
    },
    watch: {
      year (newval, oldval) {
        if (Number(newval) !== Number(oldval)) {
          this.setvalue();
        }
      },
      month (newval, oldval) {
        if (Number(newval) !== Number(oldval)) {
          this.setvalue();
        }
      },
    },
  }
</script>

<style lang="scss" scoped>
  .input-group {
    position: relative;
    label {
      padding: 2px;
      cursor: pointer;
      span {
        display: inline-block;
        width: 42px;
        height: 42px;
      }
    }
  }
  .color-picker {
    position: absolute;
    right: 2px;
    top: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/helpers/mixins/form/MonthSelect.vue